<div class="scrollingcontainer"><app-full-logo></app-full-logo>
    <app-fancy-page-title topTitle="AMERICAN EXPLORER" subTitle="Employee/Crew Login"></app-fancy-page-title>
    <!-- <app-fancy-page-title topTitle="WELCOME ABOARD" subTitle="American Explorer"></app-fancy-page-title> -->
    <div class="goldbar d-flex justify-content-center">_________</div>
    <div class="logininstructionarea">
        <div class="logininstruction d-flex justify-content-center">Please Log In to Access</div>
        <div class="logininstruction d-flex justify-content-center">American Explorer</div>
    </div>

    <form #heroForm="ngForm">

        <div class="row labelrow">
            <div class="col-6 labelcol">
                <label>Employee Number</label>
            </div>
            <div class="col-6">
                <input class="goldborder inputtext" type="text" [(ngModel)]="logincredentials.EmployeeNo"
                    name="bookingcode" #bookingcode="ngModel" required />
            </div>
        </div>
        <div class="row labelrow">
            <div class="col-6 labelcol">
                <label>Last Name</label>
            </div>
            <div class="col-6">
                <input class="goldborder inputtext" type="text" [(ngModel)]="logincredentials.LastName" name="lastname"
                    #lastname="ngModel" required />
            </div>

        </div>
    </form>

    <div class="d-flex justify-content-center errormessage">{{loginmessage}}</div>
    <div class="buttonarea d-flex justify-content-center">

        <button type="button" (click)="login($event)" class="btn btn-primary btn-lg" [disabled]="!heroForm.valid">LOG
            IN</button>

    </div>

</div>